<span [class]="'badge-project ' + clazz">
  <pr-icon
    viewBoxHeight="12"
    viewBoxWidth="12"
    width="12"
    height="12"
    [name]="icon"
  ></pr-icon>
  {{ content }}
</span>
